<template>
  <div class="py-1">    
    <label v-if="label" class="text-gray-500 text-[11px]">{{label}}</label>
    <div class="block text-sm font-medium text-gray-700">
      {{value}}
      <slot/>
    </div>
  </div>
</template>

<script>

export default {
    name: 'Text',
    props: {
        label: String,
        value: String,
    },

}
</script>